export default __webpack_public_path__ + "img/27a0cfdaa5c9ad2632e0b966718c1a88.svg";